import { render, staticRenderFns } from "./Children.vue?vue&type=template&id=5784f192&scoped=true&"
import script from "./Children.vue?vue&type=script&lang=js&"
export * from "./Children.vue?vue&type=script&lang=js&"
import style0 from "./Children.vue?vue&type=style&index=0&id=5784f192&prod&lang=scss&scoped=true&"
import style1 from "./Children.vue?vue&type=style&index=1&id=5784f192&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5784f192",
  null
  
)

export default component.exports